export default {
  title: 'Awards, Nominations and Rankings Report',
  backButton: 'Back to all reports',
  adminBackButton: 'Back to MBD Reports',
};
